"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseTablesQueryGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var DatabaseTablesByIdQueryGql_1 = require("../../queries/DatabaseTablesByIdQueryGql");
var TableRowDataFunctions_1 = require("../table/functions/TableRowDataFunctions");
var DatabaseTablesDisplayGrid_1 = require("./DatabaseTablesDisplayGrid");
function selectConnectionListResult(resultData) {
    return resultData && resultData.databases && resultData.databases[0] &&
        resultData.databases[0].tablesConnection;
}
function selectMaxCountsResult(resultData) {
    return resultData && resultData.databases && resultData.databases[0];
}
function getRowDataForTable(table, resultData) {
    return TableRowDataFunctions_1.getRowDataWithMaxCountsForTable(table, selectMaxCountsResult(resultData));
}
function DatabaseTablesQueryGrid(props) {
    return (React.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: DatabaseTablesByIdQueryGql_1.DatabaseTablesByIdQueryGql, partialQueryVariables: {
            databaseId: props.databaseId,
            orderBy: props.orderBy,
        }, selectConnectionListResult: selectConnectionListResult, mapResultNode: getRowDataForTable }, function (_a) {
        var rowStore = _a.rowStore;
        return (React.createElement(DatabaseTablesDisplayGrid_1.DatabaseTablesDisplayGrid, { rowStore: rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
    }));
}
exports.DatabaseTablesQueryGrid = DatabaseTablesQueryGrid;
//# sourceMappingURL=DatabaseTablesQueryGrid.js.map